<template lang="pug">
.program
  p.section-title Program
  .panel(
    :style="`max-height: ${calculateProgramPanelHeight}px`"
    data-test-id="program-panel"
    )
    ul
      li
        .w-50
          span.name Check in
          span.time(
            data-test-id="slidein-program-checkin-time"
          ) {{ checkIn }}
      li(
        :class="product.Key === activeBookingProduct ? 'current' : ''"
        :ref="product.Key === activeBookingProduct ? 'scrollToCurrentProduct' : undefined"
        v-for="(product, index) in scheduledProducts" :key="index"
        )
        .w-50.text-ellipsis
          span.name(
            :data-test-id="`slidein-program-scheduled-product-name-${index}`"
            :title="`${product.ProductName}`"
          ) {{ product.ProductName }}
          span.time(
            :data-test-id="`slidein-program-scheduled-product-time-${index}`"
          ) {{ bookingProductStartEndTime(product.FromDateTime, product.ToDateTime) }}
        .w-50.flex
          .quantity.mr-S
            span.square(
              :data-test-id="`slidein-program-scheduled-product-quantity-${index}`"
            ) {{ product.ProductQuantity }}
          .product
            span.square(
              :style="`background: ${product.ResourceColor}`"
              :data-test-id="`slidein-program-scheduled-resource-abbr-${index}`"
              ) {{ product.ResourceAbbreviation || createAbbreviation(product.ResourceName) }}
            span.product-name.text-ellipsis(
              :data-test-id="`slidein-program-resource-name-${index}`"
              :title="`${product.ResourceName}`"
            ) {{ product.ResourceName }}
      li
        .w-50
          span.name End
          span.time(
            data-test-id="slidein-program-end-time"
          ) {{ end }}
</template>

<script>
import { formatTimeFromUtc } from '@/helpers/dateTimeFormatter.js'
import { bookingProductStartEndTime } from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import { calculateHeight } from './overviewUtil.js'

export default {
  name: 'OverviewProgram',
  props: {
    scheduledProducts: { type: Array, required: true },
    activeBookingProduct: { type: String, required: true },
    note: { type: String, default: '' },
    nonScheduledProductsCount: { type: Number, default: 0 },
    companyLength: { type: Number, default: 0 },
    checkInTime: { type: String, required: true },
    endTime: { type: String, required: true },
  },
  computed: {
    checkIn() {
      return formatTimeFromUtc(this.$locale)(this.$timezone)(this.checkInTime)
    },
    end() {
      return formatTimeFromUtc(this.$locale)(this.$timezone)(this.endTime)
    },
    calculateProgramPanelHeight() {
      return calculateHeight({
        nonScheduledProductsCount: this.nonScheduledProductsCount,
        note: this.note,
        companyLength: this.companyLength,
      })
    },
  },
  methods: {
    bookingProductStartEndTime(startTime, endTime) {
      return bookingProductStartEndTime(startTime, endTime, this.$locale, this.$timezone)
    },
    scrollToElement() {
      const el = this.$refs.scrollToCurrentProduct

      if (el) {
        el[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    createAbbreviation(name) {
      return name.substring(0, 2).toUpperCase()
    },
  },
  mounted() {
    this.scrollToElement()
  },
}
</script>

<style lang="stylus" scoped>
.booking-card-overview .program .panel
  overflow-y scroll

  ul
    list-style none
    padding: 0
    color #999
    margin-bottom 0

    li
      overflow hidden
      position relative
      padding 0 0 15px 25px
      color #000E28
      opacity .5
      font-weight 400
      display flex
      font-size 16px
      line-height 24px

      .square
        display flex
        justify-content center
        align-items baseline

      .quantity, .product
        display flex
        justify-content left
        align-items center

      .product
        overflow hidden

      .time
        display block
        font-size 12px
        line-height 16px
        opacity .5

      .product-name
        font-size 12px
        line-height 16px
        width 80%

    li::before
      content ''
      position absolute
      left 7px
      height 100vh
      border 1px solid #96999D

    li:last-child::before
      border-width 2px 0 0

    li:first-child.current::after
      margin-top 0

    li:last-child.current::after
      margin-top 0

    li:first-child.current, li:last-child.current
      .w-50
        margin-top -8px

    li::after
      content ''
      position absolute
      left 0
      top 0
      width 17px
      height 17px
      background #96999D
      border 1px solid #96999D
      border-radius 50%

    li.current
      opacity 1
      font-size 20px
      line-height 40px

      .product-name
        font-size 16px
        line-height 24px

    li.current::before
      border-top-color #96999D
      opacity .5

    li.current::after
      border-color #008CE7
      background #008CE7
      margin-top 8px

    li:last-child
      padding-bottom 0

    li > div:first-child
      margin-top -3px
</style>
